import React from "react";

const perMonth = (p) => (p.interval === "year" ? p.price_usd / 12 : p.price_usd);

export function PlanPicker({ plans, value, onChange, compact = false }) {
  if (!plans?.length) return null;
  return (
    <div data-testid="plan-picker" className={`grid gap-2 ${plans.length === 2 ? "grid-cols-2" : "grid-cols-3"} ${compact ? "" : "mt-6 sm:gap-3"}`}>
      {plans.map((p) => {
        const on = p.lookup_key === value;
        return (
          <button
            key={p.lookup_key}
            type="button"
            data-testid={`plan-${p.lookup_key}`}
            aria-pressed={on}
            onClick={() => onChange(p.lookup_key)}
            className={`relative text-left rounded-lg border transition-colors ${compact ? "px-3 py-2" : "px-4 py-4"} ${on ? "border-oracle bg-oracle/10" : "border-white/10 hover:border-oracle/40 bg-black/20"}`}
          >
            {p.tag && (
              <span className={`absolute -top-2.5 right-2 label-caps text-[9px] px-2 py-0.5 rounded-full ${on ? "bg-oracle text-ink" : "bg-surface border border-oracle/40 text-oracle"}`}>{p.tag}</span>
            )}
            <div className={`label-caps ${on ? "text-oracle" : "text-parchment/60"}`}>{p.label}</div>
            <div className={`font-heading text-parchment ${compact ? "text-xl" : "text-2xl sm:text-3xl mt-1"}`}>
              ${p.price_usd.toFixed(2)}<span className="font-body text-xs text-parchment/45"> / {p.interval === "year" ? "yr" : "mo"}</span>
            </div>
            {!compact && (
              <div className="font-body text-[11px] text-parchment/45 mt-0.5">
                {p.interval === "year" ? `$${perMonth(p).toFixed(2)} / mo · billed yearly` : "billed monthly · cancel anytime"}
              </div>
            )}
          </button>
        );
      })}
    </div>
  );
}
